<template>
    <router-link :to="route">
        <v-btn
        height="136"
        width="100%"
        color="#001FA3">
        <div>
            <div class="useful-card-content">
                <svg v-if="!stroke"
                    width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :d="svg" fill="white"/>
                </svg>
                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                    v-if="stroke">
                    <path :d="svg" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="useful-card-text important-card-text">{{ text }}</div>
            </div>
        </div>
        </v-btn>
    </router-link>
</template>
<script>

export default{
    name: 'UsefulCard',
    props: {
        text: String,
        svg: String,
        route: String,
        stroke: Boolean
    }
}

</script>